import * as PIXI from 'pixi.js'
import * as filters from 'pixi-filters'
import { SnackbarProgrammatic as Snackbar } from 'buefy'
import { NotificationProgrammatic as Notification } from 'buefy'
import _ from 'lodash'

const R = (max=1.0) => Math.random() * max

const notification = (message) => Notification.open({
                    duration: 2500,
                    message,
                    position: 'is-top-right'
                })

const msg = (message) => Snackbar.open({queue: false, message})

class Editor {
  constructor() {
    let initWidth  = window.innerWidth,
        initHeight = window.innerHeight

    this.actions = [] // for undo etc.
    this.layers = []
    this.selectedLayer = 0

    this.app = new PIXI.Application({
      view: document.querySelector('#stage'),
      width: initWidth,
      height: initHeight,
      backgroundColor: 0x444444,
    })

    if (!Array.isArray(this.app.stage.filters)) {
      this.app.stage.filters = []
    }

    // XXX:
    this.renderer = PIXI.autoDetectRenderer(initWidth, initHeight, {
      preserveDrawingBuffer: true
    })

    //this.domElement = document.querySelector('#container')

    this.app.stage.sortableChildren = true

    this.mouseHooks()

  }

  mouseHooks() {
    this.app.stage.interactive = true
    this.app.stage.hitArea = new PIXI.Rectangle(0, 0, window.innerWidth, window.innerHeight)

    console.log('hitarea', 0, 0, window.innerWidth, window.innerHeight)

    let self = this

    this.app.stage.on('mousedown', (e) => self.onDragStart(e))
    this.app.stage.on('mouseup', (e) => self.onDragEnd(e))
    this.app.stage.on('mousemove', (e) => self.onDragMove(e))
  }

  onDragStart(event) {
    if (this.dragging) {
      this.dragging = false
      return
    }

    //console.log(event)
    let l = this.getActiveLayer()
    if (!l) {
      return
    }
    this.dragData = event.data
    this.dragging = true
  }

  onDragEnd() {
    let l = this.getActiveLayer()

    if (!l) {
      return
    }

    l.alpha = 1

    this.dragging = false
    this.dragData = null
  }

  onDragMove() {
    if (!this.dragging) {
      return
    }

    let l = this.getActiveLayer()
    if (!l) {
      return
    }

    //l1.position = new PIXI.Point(.5, .5)
    //let np = this.dragData.getLocalPosition(this.app.stage)
    let np = this.dragData.getLocalPosition(this.app.stage)
    //console.log(np)
    l.position.x = Math.max(0, np.x)
    l.position.y = Math.max(0, np.y)
  }

  logAction(action, opts=null) {
    let actionLog = {action, selectedLayer: this.selectedLayer}
    if (opts) {
      Object.assign(actionLog, opts)
    }

    this.actions.push(actionLog)
  }
  getZIndex() {
    return this.app.stage.children.length ?
      this.app.stage.children[this.app.stage.children.length-1].zIndex+10 : 0
  }
  // add url as a layer
  addURLAsLayer(url) {
    // XXX app.stage could be a new PIXI.Container / DisplayGroup
    // XXX layers
    let texture = PIXI.Texture.from(url),
        sprite = new PIXI.Sprite(texture)

    return this.addLayer(sprite)
  }
  // add texture/image to stage collection
  addLayer(sprite) {
    if (!sprite.name) {
      let numLayers = this.app.stage.children.length
      sprite.name = `L${numLayers+1}`
    }

    sprite.zIndex = this.getZIndex()

    this.app.stage.addChild(sprite)

    let layer = _.pick(sprite, ['name', 'zIndex', 'visible'])
    layer.isSelected = false

    this.layers.push(layer)
    return sprite
  }
  // get a list of layer name and settings
  _updateLayers() {
    // make sure selected layer when deleted doesn't stick around
    if (this.selectedLayer > 0
      && this.selectedLayer-1 >= this.layers.length
    ) {
      this.setCurrentLayer(this.selectedLayer-1)
    }

    this.layers = this.app.stage.children.map(sprite => {
      return _.pick(sprite, ['name', 'visible', 'zIndex'])
    })

    return this.layers
  }
  // delete layer
  deleteLayer(name) {
    let index = this.getLayerIdx(name)
    this.app.stage.removeChildAt(index)

    this._updateLayers()
  }
  // update layer zIndex and               sort sprites
  orderLayer(name, order) {
    let index = this.getLayerIdx(name)
    let zIndex = this.layers[index].zIndex
    if (order < 0) { // move down
      if (index == 0) {
        return zIndex // already at the bottom
      }

      zIndex = this.layers[index-1].zIndex-1
    } else {
      if (index >= this.layers.length-1) {
        return zIndex // already at the top
      }

      zIndex = this.layers[index+1].zIndex+1
    }
    /*XXX
    setChildIndex (child, index) inherited
    Changes the position of an existing child in the display object container
    */
    let sprite = this.app.stage.getChildAt(index)
    sprite.zIndex = zIndex
    this.layers[index].zIndex = zIndex
    this.sortLayers()

    return zIndex
  }
  sortLayers() {
    // XXX its very important order in layers is the same as the container
    this.app.stage.sortChildren()
    this.layers.sort((a,b) => a.zIndex-b.zIndex)
    //this._updateLayers()
  }
  getLayerIdx(name) {
    let numLayers = this.app.stage.children.length
    for (let index = 0; index < numLayers; index++) {
      let sprite = this.app.stage.getChildAt(index)

      if (sprite.name == name) {
        return index
      }
    }

    return -1
  }
  setCurrentLayer(idx) {
    if (idx === undefined && this.layers.length) {
      idx = this.layers.length
    }

    if (idx > this.layers.length) {
      return
    }

    this.selectedLayer = idx

    for (let i = 0; i < this.layers.length; i++) {
      this.layers[i].isSelected = false
      if (idx > 0 && i == idx-1) {
        this.layers[i].isSelected = true
      }
    }

    // todo: bind as component
    document.querySelector('.layer-sel').innerText = (idx > 0) ? idx : 'all'
  }
  toggleLayer(name) {
    let index = this.getLayerIdx(name)
    let sprite = this.app.stage.getChildAt(index)
    let visible = !sprite.visible
    sprite.visible = visible
    this.layers[index].visible = visible
    //this._updateLayers()
  }
  getActiveLayer() {
    // stage layer is group of all the layers ==> 0
    let layer = this.app.stage
    if (this.selectedLayer > 0 && this.selectedLayer <= this.layers.length) {
      layer = this.app.stage.getChildAt(this.selectedLayer-1)
    }

    return layer
  }
  // apply filter, default on stagelayer
  filter(filter, layer=null) {
    layer = layer || this.getActiveLayer()

    if (!Array.isArray(layer.filters)) {
      layer.filters = []
    }

    layer.filters.push(filter)
  }
  text(text, o={}) {
    const textSample = new PIXI.Text(text, {
        fontFamily: o.fontFamily || 'blockzone',
        fontSize: o.fontSize || 20,
        fill: o.fillColor || 'white',
        align: 'left'
    })

    textSample.zIndex = this.getZIndex()
    // XXX move this so we can fx it

    // eval? ;~pP
    /*textSample.filters = [
      new filters.GlowFilter(2, 2, 0, 0x6a93ff, .1),
    ]*/

    textSample.position.set(o.x || 10, o.y || 10)

    let numLayers = this.app.stage.children.length
    textSample.name = `T${numLayers+1}`

    return this.addLayer(textSample)
  }
  flipX(texture) {
    let l1 = new PIXI.Sprite(texture),
        l2 = new PIXI.Sprite(texture)

    l1.scale = new PIXI.Point(.5, .5)
    l1.anchor = new PIXI.Point(1, 0)
    l1.width *= -1

    l2.scale = new PIXI.Point(.5, .5)
    l2.position.x = l2.width

    let c = new PIXI.Container()
    c.addChild(l1)
    c.addChild(l2)

    let l = this.addLayer(c)
    // XXX: need to generateTexture here or smtg similar to get a texture out of
    // the sprites in the container object

    //let t = this.renderer.generateTexture(c)
    //let s = new PIXI.Sprite(t)
    //this.addLayer(s)
    //this.flipY(l.generateTexture())
  }
  flipY(texture) {
    let l1 = new PIXI.Sprite(texture),
        l2 = new PIXI.Sprite(texture)

    l1.scale = new PIXI.Point(.5, .5)
    l1.anchor = new PIXI.Point(.5, .5) //new PIXI.Point(0, 1)
    l1.height *= -1

    l2.scale = new PIXI.Point(.5, .5)
    l2.position.y = l2.height

    let c = new PIXI.Container()
    c.addChild(l1)
    c.addChild(l2)

    this.addLayer(c)

    /*
    const texture = this.renderer.generateTexture(c)
    const s = new PIXI.Sprite(texture)
    */
  }
}

export default Editor
